import classNames from 'classnames';
import { Divider } from '@components/divider';
import { Link, LinkProps } from '@components/text';
import './FooterLegalMenu.scss';

export interface FooterLegalObjectProps extends Omit<LinkProps, 'children' | 'isFooter'> {
  label: string;
}

export interface FooterLegalMenuProps {
  className?: string;
  globalMenu?: Array<FooterLegalObjectProps>;
  hasDivider?: boolean;
  weight?: LinkProps['weight'];
  centered?: boolean;
  linkComponent?: React.ElementType;
}

/**
 * FooterLegalMenu component, used in mobile footer
 * @param globalMenu - array of objects with link data
 * @param className - class passed in from Footer component
 * @param hasDivider - whether to show a divider between items
 * @param weight - text weight for the links
 * @param centered - whether to center align the menu items
 * @param linkComponent - Custom component to render links instead of a native `<a>` (e.g. Next.js Link, React Router Link).
 */
export const FooterLegalMenu: React.FC<FooterLegalMenuProps> = ({
  className,
  globalMenu = [],
  hasDivider = true,
  weight = 'regular',
  centered = false,
  linkComponent,
}) => {
  return (
    <ul
      className={classNames('vds-footer-legal-menu', className, {
        'vds-footer-legal-menu--centered': centered,
      })}>
      {globalMenu.map(item => (
        <li className="vds-footer-legal-menu__item" key={item.id}>
          {hasDivider && <Divider vertical />}
          <Link
            isFooter
            color="tertiary"
            weight={weight}
            size="small"
            linkComponent={linkComponent}
            {...item}>
            {item.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};
